export { SeoMenu } from './seo-menu';
